import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
    BrowserRouter as Router,
    Route,
    Link
} from 'react-router-dom';

import HomeScreen from './HomeScreen';
import DonateScreen from './DonateScreen';
import CharityScreen from './CharityScreen';
import VolunteerScreen from './VolunteerScreen';

class AppRoutes extends React.Component {

    constructor(props){
        super(props);

    }
    componentWillMount(){ }
    
    componentDidMount(){
        console.log('ppp')


    }



    render(){
        return (
            <Router className="Givr">
                <div>
                    <Route exact path="/" component={HomeScreen}/>
                    <Route exact path="/donate" component={DonateScreen}/>
                    <Route exact path="/volunteer" component={VolunteerScreen}/>
                    <Route exact path="/charity/:id" component={CharityScreen}/>
                    
                </div>
            </Router>
        )
    }
}

AppRoutes.propTypes = {
    
}

const mapStateProps = (state) => {
    return {
    
    };
}

export default  connect(mapStateProps, {  })(AppRoutes);



// WEBPACK FOOTER //
// ./src/components/screens/AppRoutes.js